import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { decode } from "js-base64";
import moment from "moment";

/** API */
import InvoiceApi from "../../api/invoid/invoid.api";

/** COMPONENT */
import PopupNotPayments from "../../pages/payBill/popup/PopupNotPayments";

/** UTILS */
import { routeName } from "../../routes/routers-name";
import { getProfile, getToken } from "../../utils/app.utils";

/**
 * ด่านตรวจสถานะผู้ใช้ระหว่างใช้งาน (หนี้ค้างชำระ / ยังไม่กรอกบัตรประชาชน)
 *
 * เดิมอยู่ใน App ซึ่งเป็น parent ของ <Router> จึงไม่ re-render เวลา URL เปลี่ยน
 * ตอนที่ยังเปลี่ยนหน้าด้วย full reload ไม่มีปัญหาเพราะ App ถูกสร้างใหม่ทุกครั้ง
 * แต่พอเปลี่ยนหน้าแบบ SPA แล้ว window.location.pathname ที่อ่านไว้จะค้างค่าเดิมตลอด
 * ย้ายมาไว้ใน Router แล้วอ่าน pathname จาก useLocation แทน
 */
export default function SessionGuard() {
  const { pathname } = useLocation();
  const token = getToken();
  const profile: any = token ? JSON.parse(getProfile() || "{}") : '{}';
  const checkedDateRejectUser = localStorage.getItem('STATUS_CHECKED_REJECT_USER') || null;

  const [roleId, setRoleId] = useState<number>(Number);
  const [checkedDateToRejectUser, setCheckedDateToRejectUser] = useState<boolean>(false);

  useEffect(() => {
    if (profile && token) {
      setRoleId(profile ? JSON.parse(decode(profile || ''))?.roleId : 0)
    }
  }, [profile, token])

  const checkInvoice = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 10,
      userId: JSON.parse(decode(profile || ''))?.userId,
      status: "NOT_PAY"
    }
    const res = await InvoiceApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.filter((item: any) => item.invoiceDateEnd < moment(new Date().setMonth(new Date().getMonth() - 3)).format('yyyy-MM-DD'))
      if (newData.length === 1) {
        localStorage.setItem('STATUS_CHECKED_REJECT_USER', 'OVERDUE')
        setCheckedDateToRejectUser(true)
      } else if (newData.length > 1) {
        localStorage.setItem('STATUS_CHECKED_REJECT_USER', 'SUSPEND')
        setCheckedDateToRejectUser(true)
      }
      if (pathname === '/pay-bill' || newData.length < 1) {
        localStorage.setItem('STATUS_CHECKED_REJECT_USER', '')
      }
    }
  }

  useEffect(() => {
    if (pathname === '/pay-bill') {
      localStorage.removeItem('STATUS_CHECKED_REJECT_USER')
      setCheckedDateToRejectUser(false);
    }
  }, [pathname])

  useEffect(() => {
    if (roleId === 4 || token) {
      checkInvoice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedDateRejectUser, token])

  useEffect(() => {
    /** ยังคง window.location.href ไว้ตามเดิม: หน้าแก้ไขข้อมูลส่วนตัวเป็นทางผ่านของ flow สมัคร/ยืนยันตัวตน
     *  ซึ่งพึ่งการโหลดแอปใหม่เพื่อให้ api.tsx หยิบ token ล่าสุด */
    if (token && !JSON.parse(decode(profile || "") || "")?.isIdCard && JSON.parse(decode(profile || "") || "")?.roleId === 4 && !(pathname === routeName.editProfile) && !(pathname === routeName.selectBranches)) {
      window.location.href = routeName.editProfile
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** เกินกำหนด แก้ไข flow เป็น เฉพาะหน้า */
  /* {(checkedDateRejectUser === 'OVERDUE' && roleId === 4 && checkedDateToRejectUser) && <PopupNotPayments show={checkedDateToRejectUser} />} */
  /** ระงับ */
  if (checkedDateRejectUser === 'SUSPEND' && roleId === 4 && checkedDateToRejectUser) {
    return <PopupNotPayments show={checkedDateToRejectUser} suspend={true} />
  }
  return null
}
